import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";

/**
 * Report errors from all production environments, and stage
 * @param {string} env
 */
export function shouldReportToSentry(env: string | undefined): boolean {
  if (!env) console.log("Missing config.environment");
  if (!env || typeof env !== "string") return false;
  return env.startsWith("prod") || env === "stage";
}

const MAX_TELEMETRY_DEDUPE_KEYS = 200;
const sentTelemetryKeys = new Set<string>();
export function reportTelemetryOnce(
  dedupeKey: string,
  message: string,
  extra: Record<string, unknown>
) {
  if (sentTelemetryKeys.has(dedupeKey)) {
    return;
  }

  if (sentTelemetryKeys.size >= MAX_TELEMETRY_DEDUPE_KEYS) {
    sentTelemetryKeys.clear();
  }

  sentTelemetryKeys.add(dedupeKey);
  reportMessageToSentry(message, { dedupeKey, ...extra }, "warning");
}
